<mat-form-field class="col-sm-12" floatLabel="never" style="padding-left: 0px; padding-right: 0px;">
    <input matInput [formControl]="filterControl" placeholder="Filtrar" >
</mat-form-field>
<div class="selection-box">
    <mat-selection-list style=" overflow-y: scroll;">
        <mat-list-option [value]="item" style="white-space: nowrap;"  [matTooltip]="getName(item)"
                        *ngFor="let item of currentItems">{{getName(item)}}  </mat-list-option>
    </mat-selection-list>
</div>